import { Constants, CYBER_CONSTANT } from 'constants';

import React, { useState, useEffect } from 'react';
import { AppLauncher } from '@gravity/core';
import {
  Typography,
  Grid,
  Menu,
  MenuItem,
  Button,
} from '@genie-ui/react';
import PropTypes from 'prop-types';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import ConfigPath from 'configpath';
import { LogOut, keyDownA11y, autoLogout } from 'utils';
import Logo from 'assets/images/logo-blue.svg';

import './HeaderTop.scss';
import { useSelector } from 'react-redux';

const isInvitationRoute = window?.location?.pathname?.includes(Constants.URLs.INVITATION);

function HeaderTop({
  response,
  actisKey,
  actisDataObj,
  isCyber,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (response?.primaryEmail) {
      autoLogout();
    }
  }, [response]);

  const navigateGartner = () => {
    window.open(`${ConfigPath.GARTNER_URL}/`, '_blank');
    window.pushEvent?.({
      ...Constants.ACTIS.GARTNER_ICON,
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey);
  };

  const setStateVariables = (state, val, actis) => {
    state(val);
    return (actis && window.pushEvent?.({
      ...actis,
      activityValue: val?.innerHTML ? 'true' : val.toString(),
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey));
  };

  const signOut = () => {
    window.pushEvent?.({
      ...Constants.ACTIS.SIGN_OUT,
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey);
    LogOut();
  };

  const openIntercomHelp = () => {
    window.open(CYBER_CONSTANT.INTERCOM.HELP_ROUTE, '_blank');
    window.pushEvent?.(
      {
        ...CYBER_CONSTANT.ACTIS.INTERCOM_HELP,
        ...actisDataObj,
        ...(isInvitationRoute && {
          eventParticipantEmail: user?.eventParticipantEmail,
        }),
      },
      Constants.LABELS.ACTIS_KEY_CYBER,
    );
  };

  const openAppLauncher = () => {
    window.pushEvent?.({
      ...Constants.ACTIS.APP_LAUNCHER_OPEN,
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey);
  };

  const closeAppLauncher = () => {
    window.pushEvent?.({
      ...Constants.ACTIS.APP_LAUNCHER_CLOSE,
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey);
  };

  return (
    <Grid className="header">
      <Grid container className="headerContainer">
        <Grid className="header__nameContainer">
          <div
            onClick={navigateGartner}
            onKeyDown={keyDownA11y(navigateGartner)}
            role="link"
            tabIndex={0}
          >
            <img
              className="header__logo"
              alt="logo"
              src={Logo}
            />
          </div>
          <Typography className="header__gapliteName">
            {isCyber
              && Constants.HEADER.HEADER_TITLE_CYBER}
          </Typography>
        </Grid>
        <Grid container>
          {(isCyber && response?.firstName) && (
            <Button variant="ghost" className="header__help" onClick={openIntercomHelp}>
              {CYBER_CONSTANT.BUTTON.HELP}
            </Button>
          )}
          <AccountCircleIcon
            className="header__account"
            onClick={
              (e) => setStateVariables(setAnchorEl, e.currentTarget, Constants.ACTIS.ACCOUNT_ICON)
    }
          />
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setStateVariables(setAnchorEl, null)}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'bottom',
            }}
          >
            <MenuItem disabled className="header__welcome">
              {Constants.HEADER.WELCOME}
              <br />
              {`${response?.firstName ? response.firstName : ''} ${response?.lastName ? response.lastName : ''}`}
            </MenuItem>
            <MenuItem onClick={signOut} className="header__signOut">
              <LogoutIcon />
              {Constants.BUTTON.SIGN_OUT}
            </MenuItem>
          </Menu>
          <div className="header__dividerLine" />
          <AppLauncher
            environment={ConfigPath.ENV}
            classes={{
              launcherWrapper: 'header__launcherWrapper',
              popover: 'header__appLauncherPopover',
              drawer: 'header__appLauncherDrawer',
            }}
            onAppLauncherClick={openAppLauncher}
            onAppLauncherClose={closeAppLauncher}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

HeaderTop.propTypes = {
  response: PropTypes.instanceOf(Object),
  actisKey: PropTypes.string,
  actisDataObj: PropTypes.instanceOf(Object),
  isCyber: PropTypes.bool,
};

HeaderTop.defaultProps = {
  response: {},
  actisKey: '',
  actisDataObj: {},
  isCyber: false,
};

export default HeaderTop;
